"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const hooks_1 = require("../../hooks");
const CampaignPage_1 = require("../../../../routes/Private/Emails/EmailEditor/CampaignPage");
const hooks_2 = require("../../../../hooks");
const CampaignSendPage_1 = require("./CampaignSendPage");
exports.EmailCanvasCampaignSenderView = () => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { state: { draftEmail: draft }, router: { history: { replace: historyReplace }, }, } = hooks_1.useEmailCanvasContext();
    const [activeSendView, setActiveSendView] = react_1.useState('sendCampaign');
    const { featureFlags } = hooks_2.useOsmosysContext();
    const onEmailChange = (newEmail) => {
        dispatchCanvasAction({
            data: {
                draftEmail: Object.assign(Object.assign({}, draft), newEmail),
            },
            type: 'state',
        });
    };
    const goBack = () => {
        historyReplace(`/emails/${draft.emailNumber}`);
    };
    const onBlocksChange = (newBlocks) => {
        return new Promise(resolve => {
            dispatchCanvasAction({
                data: {
                    draftEmail: Object.assign(Object.assign({}, draft), { blocks: newBlocks }),
                },
                type: 'state',
            });
            setTimeout(() => {
                resolve();
            }, 100);
        });
    };
    // eslint-disable-next-line no-constant-condition
    if (false && featureFlags.newCampaignSendPage) {
        return (react_1.default.createElement(CampaignSendPage_1.CampaignSendPage, { blocks: draft.blocks, html: draft.html, email: draft, onBlocksChange: onBlocksChange, goBack: goBack, onEmailChange: onEmailChange, toggleEmailEditButton: () => { } }));
    }
    return (react_1.default.createElement(CampaignPage_1.CampaignPage, { blocks: draft.blocks, html: draft.html, email: draft, setViewType: v => {
            setActiveSendView(v);
        }, viewType: activeSendView, onBlocksChange: onBlocksChange, goBack: goBack, onEmailChange: onEmailChange, toggleEmailEditButton: enabled => {
            dispatchCanvasAction({
                data: {
                    disableEditEmailButtonOnCampaignSendPageButton: !enabled,
                },
                type: 'state',
            });
        } }));
};
//# sourceMappingURL=index.js.map